import {
  Banner,
  BlockStack,
  Box,
  Card,
  InlineStack,
  Page,
  Tabs,
  Toast,
  Tooltip,
} from "@shopify/polaris";
import { ViewIcon } from "@shopify/polaris-icons";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import NoviceOrderModal from "../../../components/NoviceGuidance/NoviceOrderModal";
import "./index.css";
import ShopifyModal from "../../../components/ShopifyModal";
import AdditionalFilterBox from "./AdditionalPayment/AdditionalFilterBox";
import OrderListFilterBox from "./OrderList/OrderListFilterBox";
import OrderTrackingFilterBox from "./OrderTracking/OrderTrackingFilterBox";
import ManualOrderFilterBox from "./ManualOrder/ManualOrderFilterBox";
import TopUpButton from "./components/TopUpButton";
import SwitchButton from "./components/SwitchButton";
import { useSelector } from "react-redux";
import utils from "../../../utils/utils";
import AutoSourcingModal from "./modal/AutoSourcingModal";
import AutoFulfillmentModal from "./modal/AutoFulfillmentModal";
import {
  reqGetNewSubscribeList,
  reqPostBaseAction,
  reqPostNewSubscribeChange,
  reqPostSyncProcess,
  reqPostSyncShopifyOrders,
  reqPostUpdateOrderPaymentConfig,
  reqPostUpdateOrderSourcingConfig,
  reqPostUpdateSyncProcess,
} from "../../../api";
import dayjs from "dayjs";
import SyncStoreOrdersModal from "./modal/SyncStoreOrdersModal";
import EnoughQuotaModal from "../ProductSelection/SourcingRequest/component/EnoughQuotaModal";
import PersonalAgentModal from "../SubscriptionPaid/components/PersonalAgentModal";
import defalutData from "../SubscriptionPaid/components/subData";
import CommonTableFilterSkeletonList from "./common/CommonTableFilterSkeletonList";

var aliNumSourcing = 1;
var dalayTime = 5 * 1000;
const Index = () => {
  const router = useHistory();
  const plan_level = useSelector(
    (state) => state.languageReducer.subScriptData
  );
  const [isOrderBanner, setIsOrderBanner] = useState(false);
  const [initPage, setInitPage] = useState(true);
  const isGuideRef = useRef(null);
  const [noviceModal, setNoviceModal] = useState(false); //引导视频
  const [selected, setSelected] = useState(0);
  const [timers, setTimers] = useState([]); // 定时器数组
  const [syncLogData, setSyncLogData] = useState({});
  const [syncOpen, setSyncOpen] = useState(false);
  const [walletOpen, setWalletOpen] = useState(false);
  // 同步订单
  const [syncData, setSyncData] = useState({
    SyncStoreOrdersModalOpen: false, //显示弹窗
    asyncStoreOrderTotal: 0, //显示订单数量
    disabledSync: false,
    SyncBtnLoading: false, //加载状态
    showToast: false,
    isSyncFinish: false,
    SyncCompletedData: {
      all: 0,
      dropshipman: 0,
      noSource: 0,
      fail: 0,
    }, //完成同步订单数据
    showSyncBanner: false, //是否显示横幅
    finishAsyncStoreOrderCount: 0,
    synchroStatus: 1, //同步数量及状态
    synchroCount: 0,
    SyncCompletedModalOpen: false, //同步成功
  });

  // 清空所有定时器
  const clearAllTimers = () => {
    timers.forEach((timer) => {
      clearInterval(timer);
    });
  };
  // 轮询公共方法
  const setIntervalPolling = (func, func2, duration, id) => {
    func(id);
    const timer = setInterval(() => {
      func(id).then((response) => {
        if (response === 200) {
          func2(id);
          clearInterval(timer);
        }
      });
    }, duration);
    let timerArr = timers;
    timerArr.push(timer);
    setTimers(timerArr);
  };
  // 打开同步订单弹窗
  const handleSyncStoreOrdersModal = () => {
    setSyncData((prevValue) => ({
      ...prevValue,
      SyncStoreOrdersModalOpen: true,
    }));
  };

  // 接收弹窗关闭回调
  const getCloseModalCallback = (val) => {
    setSyncData((prevValue) => ({
      ...prevValue,
      SyncStoreOrdersModalOpen: val,
    }));
  };

  // 用户查看结果接口
  const getUpdateSyncProcess = async (record) => {
    const params = {
      record,
    };
    const res = await reqPostUpdateSyncProcess(params);
    if (res.code === "200") {
      setSyncData((prevValue) => {
        const params = {
          ...prevValue,
          disabledSync: false,
        };
        return params;
      });
      setSyncOpen(true);
      // getOrderListData(getSearchParam());
      // GetAppDashboardData(true)//获取数据
    }
  };

  // 同步订单轮询接口
  const getSyncStoreOrderProcess = async (record) => {
    const params = {
      record,
    };
    const res = await reqPostSyncProcess(params);
    if (res.code === "200") {
      aliNumSourcing = aliNumSourcing + 1;
      if (aliNumSourcing === 12) {
        dalayTime = 12 * 1000;
        clearAllTimers();
        setIntervalPolling(
          getSyncStoreOrderProcess,
          getUpdateSyncProcess,
          dalayTime,
          record
        );
      } else if (aliNumSourcing === 22) {
        dalayTime = 15 * 1000;
        clearAllTimers();
        setIntervalPolling(
          getSyncStoreOrderProcess,
          getUpdateSyncProcess,
          dalayTime,
          record
        );
      }
      if (aliNumSourcing >= 46) {
        dalayTime = 30 * 1000;
        clearAllTimers();
        setIntervalPolling(
          getSyncStoreOrderProcess,
          getUpdateSyncProcess,
          dalayTime,
          record
        );
      }
      // 更新剩余值
      if (res.data.is_sync === 0) {
        setSyncData((prevValue) => {
          const params = {
            ...prevValue,
            isSyncFinish: true, // 同步是否完成
            SyncCompletedData: {
              all: res.data.all_count,
              dropshipman: res.data.dsm_count,
              noSource: res.data.no_source_count,
              fail: res.data.fail_count,
            },
            disabledSync: false,
          };
          return params;
        });

        return 200;
      }
      setSyncData((prevValue) => {
        const params = {
          ...prevValue,
          disabledSync: true,
          isSyncFinish: false,
          finishAsyncStoreOrderCount: res.data.surplus_count,
        };
        return params;
      });
    } else {
      clearAllTimers();
      setSyncData((prevValue) => {
        const params = {
          ...prevValue,
          disabledSync: false,
        };
        return params;
      });

      return 200;
    }
  };

  const handleSyncStoreOrders = async (start, end) => {
    const params = {
      start: dayjs(start).format("YYYY-MM-DD"),
      end: dayjs(end).format("YYYY-MM-DD"),
    };

    const res = await reqPostSyncShopifyOrders(params);
    if (res.code === "200") {
      setSyncData((prevValue) => {
        const params = {
          ...prevValue,
          SyncStoreOrdersModalOpen: false,
          asyncStoreOrderTotal: res.data.all_count,
          disabledSync: true,
          SyncBtnLoading: false,
          showToast: false,
        };
        toastFun("Order syncing");
        return params;
      });

      if (res.data.all_count) {
        // 吊起轮询接口 并显示banner
        setSyncData((prevValue) => {
          const params = {
            ...prevValue,
            showSyncBanner: true,
            isSyncFinish: false,
          };
          return params;
        });

        setIntervalPolling(
          getSyncStoreOrderProcess,
          getUpdateSyncProcess,
          dalayTime,
          res.data.record
        );
        // getSyncStoreOrderProcess(res.data.record);
        // let timer = setInterval(() => {
        //   getSyncStoreOrderProcess(res.data.record).then((response) => {
        //     if (response === 200) {
        //       getUpdateSyncProcess(res.data.record);
        //       clearInterval(timer);
        //     }
        //   });
        // }, dalayTime);
      } else {
        setSyncData((prevValue) => {
          const params = {
            ...prevValue,
            showSyncBanner: true,
            isSyncFinish: true,
            disabledSync: false,
            SyncCompletedData: {
              all: res.data.all_count,
              dropshipman: res.data.dsm_count,
              noSource: res.data.no_source_count,
              fail: res.data.fail_count,
            },
          };
          return params;
        });
        setSyncOpen(true);
        // getOrderListData(getSearchParam());
      }
    }
  };

  // 同步订单回调
  const getSyncCallback = (start, end) => {
    setSyncData((prevValue) => {
      const params = {
        ...prevValue,
        SyncBtnLoading: true,
      };
      return params;
    });

    handleSyncStoreOrders(start, end);
  };

  // 关闭同步订单成功弹窗
  const closeSyncCompletedModal = () => {
    setSyncData((prevValue) => {
      const params = {
        ...prevValue,
        SyncCompletedModalOpen: false,
      };
      return params;
    });
  };

  const handleTabChange = useCallback(
    (selectedTabIndex) => {
      const { search } = router.location;
      const params = new URLSearchParams(search);
      // 转换为数字并验证范围
      let selectedView = Number(selectedTabIndex);
      if (isNaN(selectedView) || selectedView < 0 || selectedView > 3) {
        selectedView = 0;
      }

      // 仅在参数不合法或需要设置默认值时更新URL
      if (selectedTabIndex !== String(selectedView)) {
        params.set("selectedView", selectedView);
        // 使用replace避免新增历史记录
        router.replace({
          search: params.toString(),
        });
        utils.routeJump1(
          router,
          "/admin/order_fulfillment?selectedView=" + selectedView
        );
      }
      setSelected(selectedTabIndex);
    },
    [router]
  );
  useEffect(() => {
    const { search, pathname } = router.location;
    const params = new URLSearchParams(search);
    const selectedViewParam = params.get("selectedView");
    // 转换为数字并验证范围
    let selectedView = Number(selectedViewParam);
    if (isNaN(selectedView) || selectedView < 0 || selectedView > 3) {
      selectedView = 0;
    }
    

    // 仅在参数不合法或需要设置默认值时更新URL
    if (selectedViewParam !== String(selectedView)) {
      params.set("selectedView", selectedView);
      // 使用replace避免新增历史记录
      router.replace({
        search: params.toString(),
      });
      const newPath = params.toString()
        ? `${pathname}?${params.toString()}`
        : pathname;
        window.history.replaceState({}, "", newPath);
      // utils.routeListen(newPath);
    }
    setSelected(selectedView);
    setTimeout(() => {
      setInitPage(false);
    }, 1500);
  }, [router]); // 确保将router加入依赖数组
  // 进入页面判断是否需要轮询
  useEffect(() => {
    let isMount = true;
    if (isMount) {
      let syncLog =
        Object.values(syncLogData).length > 0 ? syncLogData.sync_log : [];
      if (Object.keys(syncLog).length) {
        if (syncLog.is_sync === 1) {
          setSyncData((prevValue) => {
            const params = {
              ...prevValue,
              isSyncFinish: false,
              showSyncBanner: true,
              disabledSync: true,
              finishAsyncStoreOrderCount: syncLog.surplus_count,
              asyncStoreOrderTotal: syncLog.all_count,
            };
            return params;
          });
          setIntervalPolling(
            getSyncStoreOrderProcess,
            getUpdateSyncProcess,
            dalayTime,
            syncLog.record
          );
        } else {
          setSyncData((prevValue) => {
            const params = {
              ...prevValue,
              isSyncFinish: true,
              showSyncBanner: true,
              disabledSync: false,
              SyncCompletedData: {
                all: syncLog.all_count,
                dropshipman: syncLog.dsm_count,
                noSource: syncLog.no_source_count,
                fail: syncLog.fail_count,
              },
            };
            return params;
          });

          getUpdateSyncProcess(syncLog.record);
        }
      }
    }
    return () => {
      isMount = false;
      clearAllTimers();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [syncLogData]);
  const [walletData, setWalletData] = useState(0);
  const [autoData, setAutoData] = useState({
    autoSourcing: false,
    autoSourcingModal: false,
    autoPlanSourcing: false,
    autoFulfillment: false,
    autoFulfillmentModal: false,
    autoPlanFulfillment: false,
  });
  const orderPaymentConfigOff = async (newValue) => {
    const res = await reqPostUpdateOrderPaymentConfig({
      auto_pay: 0,
      auto_complete: 0,
      userShippingData: "",
    });
    if (res.code === "200") {
      if (!newValue) {
        setAutoData((prev) => ({
          ...prev,
          autoFulfillment: newValue,
          autoFulfillmentModal: false,
        }));
        toastFun("Set up successfully");
      }
    } else {
      toastFun(res.msg);
    }
  };
  // 次数不足
  const [sourcingLimitModal, setSourcingLimitModal] = useState(false);
  // 自动source开关
  const handleAutoSourcing = (flag) => {
    if (plan_level.level > 0 && plan_level.level !== 4) {
      if (flag) {
        setAutoData((prev) => ({
          ...prev,
          autoSourcingModal: true,
        }));
      } else {
        orderSourcingPaymentConfigOff(flag);
      }
    } else {
      setAutoData((prev) => ({
        ...prev,
        autoPlanFulfillment: false,
        autoPlanSourcing: true,
      }));
      setSourcingLimitModal(true);
    }
  };

  const [saveLoading, setSaveLoading] = useState(false);
  const orderSourcingPaymentConfigOff = async (newValue) => {
    setSaveLoading(true);
    const res = await reqPostUpdateOrderSourcingConfig({
      checked: newValue ? 1 : 0,
    });
    if (res.code === "200") {
      toastFun("Set up successfully");
      setAutoData((prev) => ({
        ...prev,
        autoSourcingModal: false,
        autoSourcing: newValue,
      }));
    } else {
      toastFun(res.msg);
    }
    setSaveLoading(false);
  };
  // 自动fulfillment开关

  // 切换自动支付
  const handleAutoFulfillment = (newValue) => {
    if (plan_level.level > 0 && plan_level.level !== 4) {
      if (newValue) {
        setAutoData((prev) => ({
          ...prev,
          autoFulfillmentModal: true,
        }));
      } else {
        orderPaymentConfigOff(newValue);
      }
    } else {
      setAutoData((prev) => ({
        ...prev,
        autoPlanFulfillment: true,
        autoPlanSourcing: false,
      }));
      setSourcingLimitModal(true);
    }
  };
  const tabs = [
    {
      id: "all-customers-1",
      content: (
        <Tooltip
          preferredPosition="below"
          content={"Orders from Shopify stores"}
          hasUnderline
        >
          <span>Store Orders</span>
        </Tooltip>
      ),
      accessibilityLabel: "All customers",
      panelID: "all-customers-content-1",
    },
    {
      id: "accepts-marketing-1",
      content: (
        <Tooltip
          preferredPosition="below"
          hasUnderline
          content={
            "Shopify store order tracking, with automatic tracking creation after successful payment in Dropshipman"
          }
        >
          <span>Order Tracking</span>
        </Tooltip>
      ),
      panelID: "accepts-marketing-content-1",
    },
    {
      id: "repeat-customers-1",
      content: (
        <Tooltip
          preferredPosition="below"
          hasUnderline
          content={
            "Additional paid orders, such as shipping differences or customization fees"
          }
        >
          <span>Additional Payment</span>
        </Tooltip>
      ),
      panelID: "repeat-customers-content-1",
    },
    {
      id: "prospects-1",
      content: (
        <Tooltip
          preferredPosition="below"
          hasUnderline
          content={
            "Manually created orders in Dropshipman, non-Shopify store orders"
          }
        >
          <span>Manual Orders</span>
        </Tooltip>
      ),
      panelID: "prospects-content-1",
    },
  ];

  const [planShow, setPlanShow] = useState(true);
  const [subList, setSubList] = useState(defalutData.subList); // 套餐列表

  // 高级套餐
  const [premiumData, setPremiumData] = useState({
    open: false,
    agent_list: [],
  });
  const handlePremiumOff = () => {
    setPremiumData((prevValue) => ({
      ...prevValue,
      open: false,
    }));
  };
  const enhancePackageList = (
    list,
    currentPlanId,
    pricingData,
    trialDays,
    agentList,
    firstPurchase,
    isZt,
    glassesLevel
  ) =>
    list.map((item) => {
      const priceInfo = pricingData.find((p) => p.key === item.id) || {};
      const isCurrentPlan = item.id === currentPlanId;
      const isAnnualPlan = priceInfo?.is_yearly === 1;
      let button = "";
      let disabled = false;
      if (glassesLevel === 1) {
        // 当前为年套餐页
        if (isAnnualPlan) {
          if (isCurrentPlan) {
            // 当前为年套餐页、未购买年套餐的
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else {
              button = "Current Plan";
              disabled = true;
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            button = "Downgrade";
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        } else {
          if (isCurrentPlan) {
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            if (item.id === 4 && currentPlanId === 0) {
              button = "Select Plan";
            } else {
              button = "Downgrade";
            }
          }
        }
      } else {
        if (isAnnualPlan) {
          if (isCurrentPlan) {
            // 当前为年套餐页、未购买年套餐的
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else if (trialDays !== 0 && item.id !== 4) {
              button = `Start ${trialDays}-day free trial`;
            } else {
              button = "Select Plan";
            }
          } else if (item.id === 0 && item.id !== currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        } else {
          if (isCurrentPlan) {
            if (currentPlanId === 0) {
              // 未付费用户
              button = "Current Plan";
              disabled = true;
            } else if (item.id === 0) {
              button = "Downgrade";
            } else {
              button = "Current Plan";
              disabled = true;
            }
          } else if (
            (item.id === 0 && item.id !== currentPlanId) ||
            (item.id === 4 && currentPlanId !== 0 && !isCurrentPlan)
          ) {
            button = "Downgrade";
          } else if (currentPlanId !== 4 && item.id < currentPlanId) {
            button = "Downgrade";
          } else if (trialDays !== 0 && item.id !== 4) {
            button = `Start ${trialDays}-day free trial`;
          } else {
            button = "Select Plan";
          }
        }
      }

      return {
        ...item,
        ...priceInfo,
        first_purchase: firstPurchase,
        is_zt: isZt,
        level: currentPlanId,
        agent: item.id === 5 ? agentList : [],
        button,
        disabled,
        loading: false,
      };
    });
    const handleNewParnter = async (val) => {
      const params = {
        type: val,
      };
      let res = await reqPostBaseAction(params);
      if (res.code === '200') {
        setIsOrderBanner(false)
      }
    };
  // 获取套餐数据
  const getSubscribeList = async () => {
    try {
      let res = await reqGetNewSubscribeList();
      if (res.code === "200") {
        setIsOrderBanner(plan_level.order_list_ads);
        const {
          level,
          trial_days,
          agent_list,
          first_purchase,
          is_zt,
          glasses_level,
        } = res.data;
        setPremiumData((prevValue) => ({
          ...prevValue,
          agent_list: res.data.agent_list,
        }));
        setPlanShow(glasses_level === 1 ? false : true);
        // 处理月套餐
        const enhancedMonth = enhancePackageList(
          subList.month,
          level,
          res.data.package.month,
          trial_days,
          agent_list,
          first_purchase,
          is_zt,
          glasses_level
        );
        // 处理年套餐
        const enhancedYear = enhancePackageList(
          subList.year,
          level,
          res.data.package.year,
          trial_days,
          agent_list,
          first_purchase,
          is_zt,
          glasses_level
        );

        setSubList((prev) => ({
          ...prev,
          month: enhancedMonth,
          year: enhancedYear,
        }));
      }
    } catch (error) {}
  };

  useEffect(() => {
    let isMount = false;
    if (!isMount) {
      getSubscribeList();
    }
    return () => {
      isMount = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // 升降级
  const handleMageUpgrade = async (
    id,
    val = "",
    email = "",
    social = "",
    am_id = ""
  ) => {
    try {
      let param = {
        package_id: id,
        email: email,
        social: social,
        am_id: am_id,
        is_yearly: !planShow ? 1 : 0,
      };
      if (val && val !== "") {
        param.remark = val;
      }

      let res = await reqPostNewSubscribeChange(param);
      if (res.code === "200") {
        if (res?.data?.id !== "") {
          if (id !== 0) {
            window.top.location.href = res.data.url;
            toastFun(res.msg);
          }
        }
      } else {
        toastFun("Something wrong");
      }
    } catch (error) {}
  };

  const handleSubmit = (val) => {
    if (val) {
      if (val === 5) {
        setPremiumData((prevValue) => ({
          ...prevValue,
          open: true,
        }));
        setSourcingLimitModal(false);
      }

      if (val < 5) {
        handleMageUpgrade(val);
      }
    }
  };
  const handleSoureOff = (value) => {
    setSourcingLimitModal(value);
  };
  const isReachLimit = useMemo(() => {
    let flag = false;
    if (plan_level.level === 0 || plan_level.level === 4) {
      flag = true;
    }
    return flag;
  }, [plan_level]);
  const [toast, setToast] = useState(false); // 提示
  const [toastError, setToastError] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const toggleToast = useCallback(() => setToast((toast) => !toast), []);

  const toastMarkup = toast ? (
    <Toast content={toastMsg} onDismiss={toggleToast} error={toastError} />
  ) : null;

  const toastFun = (msg, error) => {
    setToastError(error);
    setToastMsg(msg);
    setToast(false);
    toggleToast();
  };

  //判断是否同步中
  var synchroContent = "";
  if (syncData?.synchroStatus === 0) {
    synchroContent = (
      <div style={{ paddingTop: "2rem" }}>
        <Banner tone="info">
          <p>
            {syncData.synchroCount} {"Order in processing"}{" "}
            <img
              src="data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMjI5IDEuMTczYTkuMjUgOS4yNSAwIDEgMCAxMS42NTUgMTEuNDEyIDEuMjUgMS4yNSAwIDEgMC0yLjQtLjY5OCA2Ljc1IDYuNzUgMCAxIDEtOC41MDYtOC4zMjkgMS4yNSAxLjI1IDAgMSAwLS43NS0yLjM4NXoiIGZpbGw9IiM5MTlFQUIiLz48L3N2Zz4K"
              alt=""
              className="Polaris-Spinner Polaris-Spinner--sizeSmalltow"
              draggable="false"
              role="status"
              aria-label="Loading"
            ></img>
          </p>
        </Banner>
      </div>
    );
  }

  //同步完成弹窗
  const SyncCompletedModal = (
    <ShopifyModal
      id="sync-completed-modal"
      open={syncData.SyncCompletedModalOpen}
      onClose={() => closeSyncCompletedModal()}
      heading="Completed"
      primaryAction={{
        content: "OK",
        onAction: () => closeSyncCompletedModal(),
      }}
    >
      
        <div className="SyncCompletedModalContent">
          <BlockStack>
            <BlockStack>
              <p>
                <span>
                  {Number(syncData.SyncCompletedData?.all) -
                    Number(syncData.SyncCompletedData?.fail)}
                </span>{" "}
                {"orders have been synchronized successfully"}.
              </p>
            </BlockStack>
            <BlockStack>
              <p>
                {" "}
                <span>{syncData.SyncCompletedData?.fail}</span>{" "}
                {"orders failed to synchronize."}
              </p>
            </BlockStack>
          </BlockStack>
        </div>
      
    </ShopifyModal>
  );

  const skeletonPage = (
    <Box className="skeleton_page_children">
    <Page
  fullWidth={true}
  title="Order Fulfillment"
  primaryAction={
    initPage
      ? undefined
      : selected === 0
      ? {
          id: "s1",
          content: "Sync Store Orders",
          variant: "primary",
          onAction: () => handleSyncStoreOrdersModal(),
        }
      : undefined
  }
  secondaryActions={
    initPage
      ? []
      : selected === 0
      ? [
          {
            key: "p1",
            icon: ViewIcon,
            content: <span>Watch Tutorial</span>,
            onAction: () => {
              setNoviceModal(true);
            },
          },
          {
            key: "p2",
            disabled: isReachLimit,
            content: (
              <span>
                <InlineStack blockAlign="center" gap={100}>
                  <span>Auto Order Sourcing</span>
                  <SwitchButton
                    open={autoData.autoSourcing}
                    handleSwitch={handleAutoSourcing}
                  />
                </InlineStack>
              </span>
            ),
            onAction: () => {},
          },
          {
            key: "p3",
            disabled: isReachLimit,
            content: (
              <span>
                <InlineStack blockAlign="center" gap={100}>
                  <span>Auto Fulfillment</span>
                  <SwitchButton
                    open={autoData.autoFulfillment}
                    handleSwitch={handleAutoFulfillment}
                  />
                </InlineStack>
              </span>
            ),
            onAction: () => {},
          },
          {
            key: "p4",
            content: (
              <span>
                <InlineStack blockAlign="center" gap={100}>
                  <span>
                    <img height={16} src="/dsm_pay.png" alt="dsm_pay" />
                  </span>
                  <span
                    style={{ fontWeight: 650, color: "rgba(0, 0, 0, 1)" }}
                  >
                    Dropshipman Credit
                  </span>
                  <span
                    style={{
                      width: "1px",
                      height: "12px",
                      background: "rgba(204, 204, 204, 1)",
                    }}
                  ></span>
                  <span style={{ color: "rgba(0, 91, 211, 1)" }}>
                    ${walletData}
                  </span>
                  <span
                    className="fulfillment_top_up"
                    onClick={() => setWalletOpen(true)}
                  >
                    {"Top Up"}
                  </span>
                </InlineStack>
              </span>
            ),
            accessibilityLabel: "Secondary action label",
            onAction: () => {},
          },
        ]
      : [
          {
            key: "p4",
            content: (
              <span>
                <InlineStack blockAlign="center" gap={100}>
                  <span>
                    <img height={16} src="/dsm_pay.png" alt="dsm_pay" />
                  </span>
                  <span
                    style={{ fontWeight: 650, color: "rgba(0, 0, 0, 1)" }}
                  >
                    Dropshipman Credit
                  </span>
                  <span
                    style={{
                      width: "1px",
                      height: "12px",
                      background: "rgba(204, 204, 204, 1)",
                    }}
                  ></span>
                  <span style={{ color: "rgba(0, 91, 211, 1)" }}>
                    ${walletData}
                  </span>
                  <span
                    className="fulfillment_top_up"
                    onClick={() => setWalletOpen(true)}
                  >
                    {"Top Up"}
                  </span>
                </InlineStack>
              </span>
            ),
            accessibilityLabel: "Secondary action label",
            onAction: () => {},
          },
        ]
  }
>
  <Box
    className={
      isGuideRef
        ? "order_fulfillment_page order_fulfillment_page_guide"
        : "order_fulfillment_page"
    }
  >
    <Box className="order_fulfillment_page_tab">
      <Tabs
        tabs={tabs}
        selected={selected}
        onSelect={handleTabChange}
      ></Tabs>
    </Box> <CommonTableFilterSkeletonList /></Box></Page>
    </Box>
  )
  const pageContent = (
    <Page
      fullWidth={true}
      title="Order Fulfillment"
      primaryAction={
        initPage
          ? undefined
          : {
              id: "s1",
              content: "Sync Store Orders",
              variant: "primary",
              disabled:selected !== 0,
              onAction: () => handleSyncStoreOrdersModal(),
            }
      }
      secondaryActions={
        initPage
          ? []
          : [
              {
                key: "p1",
                icon: ViewIcon,
                content: <span>Watch Tutorial</span>,
                onAction: () => {
                  setNoviceModal(true);
                },
              },
              {
                key: "p2",
                disabled: isReachLimit,
                content: (
                  <span>
                    <InlineStack blockAlign="center" gap={100}>
                      <span>Auto Order Sourcing</span>
                      <SwitchButton
                        open={autoData.autoSourcing}
                        handleSwitch={handleAutoSourcing}
                      />
                    </InlineStack>
                  </span>
                ),
                onAction: () => {},
              },
              {
                key: "p3",
                disabled: isReachLimit,
                content: (
                  <span>
                    <InlineStack blockAlign="center" gap={100}>
                      <span>Auto Fulfillment</span>
                      <SwitchButton
                        open={autoData.autoFulfillment}
                        handleSwitch={handleAutoFulfillment}
                      />
                    </InlineStack>
                  </span>
                ),
                onAction: () => {},
              },
              {
                key: "p4",
                content: (
                  <span>
                    <InlineStack blockAlign="center" gap={100}>
                      <span>
                        <img height={16} src="/dsm_pay.png" alt="dsm_pay" />
                      </span>
                      <span
                        style={{ fontWeight: 650, color: "rgba(0, 0, 0, 1)" }}
                      >
                        Dropshipman Credit
                      </span>
                      <span
                        style={{
                          width: "1px",
                          height: "12px",
                          background: "rgba(204, 204, 204, 1)",
                        }}
                      ></span>
                      <span style={{ color: "rgba(0, 91, 211, 1)" }}>
                        ${walletData}
                      </span>
                      <span
                        className="fulfillment_top_up"
                        onClick={() => setWalletOpen(true)}
                      >
                        {"Top Up"}
                      </span>
                    </InlineStack>
                  </span>
                ),
                accessibilityLabel: "Secondary action label",
                onAction: () => {},
              },
            ]
      }
    >
      <Box
        className={
          isGuideRef
            ? "order_fulfillment_page order_fulfillment_page_guide"
            : "order_fulfillment_page"
        }
      >
        <Box className="order_fulfillment_page_tab">
          <Tabs
            tabs={tabs}
            selected={selected}
            onSelect={handleTabChange}
          ></Tabs>
        </Box>
        {/* 同步订单banner */}
        {selected === 0 && syncData.showSyncBanner && (
          <div style={{ marginBottom: "16px" }}>
            <Banner
              title={
                syncData.isSyncFinish
                  ? "Order synchronization completed"
                  : "Orders are in sync..."
              }
              tone="info"
              onDismiss={
                syncData.isSyncFinish
                  ? () => {
                      // this.setState({
                      //   showSyncBanner: false
                      // })
                      setSyncData((prevValue) => {
                        const params = {
                          ...prevValue,
                          showSyncBanner: false,
                        };
                        return params;
                      });
                    }
                  : () => {}
              }
            >
              {syncData.isSyncFinish ? (
                <p className="SyncBanner">
                  <span>
                    {Number(syncData.SyncCompletedData?.all) -
                      Number(syncData.SyncCompletedData?.fail)}
                  </span>{" "}
                  {"orders have been synchronized successfully"},{" "}
                  <span>{syncData.SyncCompletedData?.fail}</span>{" "}
                  {"orders failed to synchronize."}
                </p>
              ) : (
                <p>
                  {syncData?.asyncStoreOrderTotal -
                    syncData?.finishAsyncStoreOrderCount}
                  /{syncData?.asyncStoreOrderTotal}
                </p>
              )}
            </Banner>
          </div>
        )}
        {synchroContent}
        <Card roundedAbove="sm" padding="0">
          {selected === 0 && (
            <OrderListFilterBox
              toastFun={toastFun}
              setWalletData={setWalletData}
              setAutoData={setAutoData}
              setSyncLogData={setSyncLogData}
              syncOpen={syncOpen}
              setSyncOpen={setSyncOpen}
              handleStoreTabChange={handleTabChange}
              isGuideRef={isGuideRef}
            />
          )}
          {selected === 1 && (
            <OrderTrackingFilterBox
              handleStoreTabChange={handleTabChange}
              toastFun={toastFun}
              setWalletData={setWalletData}
              syncOpen={syncOpen}
              setSyncOpen={setSyncOpen}
            />
          )}
          {selected === 2 && (
            <AdditionalFilterBox
              toastFun={toastFun}
              setWalletData={setWalletData}
              syncOpen={syncOpen}
              setSyncOpen={setSyncOpen}
            />
          )}
          {selected === 3 && (
            <ManualOrderFilterBox
              toastFun={toastFun}
              setWalletData={setWalletData}
              syncOpen={syncOpen}
              setSyncOpen={setSyncOpen}
            />
          )}
        </Card>
      </Box>
    </Page>
  );
  const StarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path d="M14.25 11.75C14.25 11.3358 13.9142 11 13.5 11C13.0858 11 12.75 11.3358 12.75 11.75V13.3964C12.75 13.6617 12.8554 13.916 13.0429 14.1036L13.7197 14.7803C14.0126 15.0732 14.4874 15.0732 14.7803 14.7803C15.0732 14.4874 15.0732 14.0126 14.7803 13.7197L14.25 13.1893V11.75Z" fill="black"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M11.0932 2.91424C10.4541 2.40294 9.54592 2.40293 8.90679 2.91424L8.58988 3.16777C7.60347 3.9569 6.52283 4.6204 5.37281 5.14305L4.52596 5.52791C3.90734 5.80905 3.4829 6.43911 3.51511 7.15553C3.79613 13.4047 7.8959 16.2031 9.2485 16.9575C9.6912 17.2044 10.2185 17.2183 10.6708 16.9995C11.4437 17.6252 12.4281 18 13.5 18C15.9853 18 18 15.9853 18 13.5C18 11.9851 17.2514 10.645 16.104 9.82953C16.3064 9.02356 16.4416 8.14025 16.485 7.17442C16.517 6.46179 16.097 5.83426 15.4834 5.55104L14.5832 5.13558C13.4633 4.61873 12.4103 3.96793 11.4472 3.19745L11.0932 2.91424ZM9 13.5C9 14.1253 9.12752 14.7207 9.35797 15.2618C7.88587 14.258 5.22577 11.8063 5.0136 7.08815C5.01058 7.02102 5.05113 6.93687 5.14657 6.8935L5.99342 6.50864C7.25656 5.93459 8.44349 5.20582 9.52692 4.33907L9.84383 4.08554C9.93513 4.0125 10.0649 4.0125 10.1562 4.08554L10.5102 4.36875C11.568 5.21502 12.7246 5.92983 13.9546 6.49752L14.8548 6.91298C14.9494 6.95666 14.9895 7.04038 14.9865 7.10707C14.9532 7.84867 14.859 8.53419 14.7182 9.16683C14.3307 9.05813 13.9222 9 13.5 9C11.0147 9 9 11.0147 9 13.5ZM13.5 16.5C15.1569 16.5 16.5 15.1569 16.5 13.5C16.5 11.8431 15.1569 10.5 13.5 10.5C11.8431 10.5 10.5 11.8431 10.5 13.5C10.5 15.1569 11.8431 16.5 13.5 16.5Z" fill="black"/>
    </svg>
  );
  return (
    <div className="skeleton_page">
      {initPage && skeletonPage}
       <div style={{opacity: initPage ? 0 : 1}}>
       {isOrderBanner && <Box className="" style={{padding: '24px 24px 0 24px'}}>
              <Banner
              icon={StarIcon}
                // hideIcon={true}
                title={`Protectify- Order Shipping Protection`}
                onDismiss={() => {
                  handleNewParnter('ads_order');
                }}
                action={{ content: "Start for free", url: "https://apps.shopify.com/protectify-shipping-protectio?source=dropshipman_order_list",external: true }}
              >
                <p>
                Protect your orders from loss, damage, or theft — and turn protection into profit by earning more from protected orders.
                </p>
              </Banner>
            </Box>}
        {pageContent}
      </div>
      {toastMarkup}
      {/* 功能视频介绍 */}
      {walletOpen && <TopUpButton setWalletOpen={setWalletOpen} />}
      <NoviceOrderModal
        upgradeOpen={noviceModal}
        setUpgradeOpen={() => setNoviceModal(false)}
      />
      {/* 手动同步订单弹窗 */}
      <SyncStoreOrdersModal
        searchStartDay={syncData.searchStartDay}
        searchEndDay={syncData.searchEndDay}
        open={syncData.SyncStoreOrdersModalOpen}
        loading={syncData.SyncBtnLoading}
        closeModalCallback={getCloseModalCallback}
        syncCallback={getSyncCallback}
      />
      {syncData.SyncCompletedModalOpen ? SyncCompletedModal : ""}
      {/* 自动支付 */}
      <AutoFulfillmentModal
        open={autoData.autoFulfillmentModal}
        toastFun={toastFun}
        setAutoData={setAutoData}
        setSwitchChecked={() => {
          setAutoData((prev) => ({
            ...prev,
            autoFulfillmentModal: false,
          }));
        }}
      />
      {/* 自动sourcing确认 */}
      <AutoSourcingModal
        open={autoData.autoSourcingModal}
        setSwitchSourcingOpen={() => {
          setAutoData((prev) => ({
            ...prev,
            autoSourcingModal: false,
          }));
        }}
        saveLoading={saveLoading}
        handleSourcingConfigOff={orderSourcingPaymentConfigOff}
      />

      {/* 次数不够 */}
      <EnoughQuotaModal
        type={autoData.autoPlanSourcing ? "auto_sourcing" : "auto_fulfillment"}
        sourceLess={{}}
        planShow={planShow}
        handleSubmit={handleSubmit}
        sourcingLimitModal={sourcingLimitModal}
        userPoints={{
          userPointsData: {
            available_points: 0,
            total_points: 0,
          },
          userPointsRedeem: {
            open: false,
            id: 0,
            isDetail: false,
            is_new: 0,
            isPoints: false,
          },
        }}
        subList={subList}
        setSourcingLimitModal={handleSoureOff}
      />
      {/* agent选择 */}
      <PersonalAgentModal
        premiumData={premiumData}
        handlePremiumOff={handlePremiumOff}
        handleMageUpgrade={handleMageUpgrade}
      />
    </div>
  );
};

export default Index;
